interface Props {
  series: number[];
  /** Stroke colour (defaults to the inherited status colour var). */
  color?: string;
}

/** Stripped sparkline for table rows / pills: no axes, no grid, no fill, no dot. */
export function Sparkline({ series, color = "var(--sc)" }: Props) {
  const pts = series.length >= 2 ? series : [series[0] ?? 0, series[0] ?? 0];
  const min = Math.min(...pts);
  const max = Math.max(...pts);
  const span = max - min || 1;
  const W = 60, H = 18;
  const step = W / (pts.length - 1 || 1);
  const d = pts.map((v, i) => {
    const x = i * step;
    const y = H - ((v - min) / span) * (H - 3) - 1.5;
    return `${i ? "L" : "M"}${x.toFixed(1)} ${y.toFixed(1)}`;
  }).join(" ");
  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true">
      <path d={d} fill="none" stroke={color} strokeWidth="1.3" strokeLinejoin="round"
        strokeLinecap="round" vectorEffect="non-scaling-stroke" opacity="0.85" />
    </svg>
  );
}
